import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { loadCountries, loadProviders, logoutReducers, resetErrors, setError, setListExpanded, setMenuExpanded } from './commonActions';
import { CommonBaseState, initialCommonBaseState } from '../../interfaces/redux/common';
import { Country, Provider } from '../../interfaces/dtos/common';

export interface CommonState extends CommonBaseState {
    menuExpanded: boolean;
    listExpanded: boolean;
    loadingCountries: boolean;
    loadingProviders: boolean;

    countries: Country[];
    providers: Provider[];
}

const initialState: CommonState = {
    ...initialCommonBaseState,

    menuExpanded: true,
    listExpanded: true,
    loadingCountries: false,
    loadingProviders: false,

    countries: [],
    providers: []
};

export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        errorOccured: (state, action: PayloadAction<string>) => {
            state.error = true;
            state.errorMessage = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            // loadCountries
            .addCase(loadCountries.pending, (state) => {
                state.loadingCountries = true;
            })
            .addCase(loadCountries.fulfilled, (state, action) => {
                state.loadingCountries = false;
                state.countries = action.payload;
            })
            .addCase(loadCountries.rejected, (state, action) => {
                state.loadingCountries = false;
                state.error = true;
                state.errorMessage = `Could not load countries:\r\n${action.error.message}`;
            })

            // loadProviders
            .addCase(loadProviders.pending, (state) => {
                state.loadingProviders = true;
            })
            .addCase(loadProviders.fulfilled, (state, action) => {
                state.loadingProviders = false;
                state.providers = action.payload;
            })
            .addCase(loadProviders.rejected, (state, action) => {
                state.loadingProviders = false;
                state.error = true;
                state.errorMessage = `Could not load providers:\r\n${action.error.message}`;
            })

            // setMenuExpanded
            .addCase(setMenuExpanded.fulfilled, (state, action) => {
                state.menuExpanded = action.payload;
            })
            // setListExpanded
            .addCase(setListExpanded.fulfilled, (state, action) => {
                state.listExpanded = action.payload;
            })

            // Set error
            .addCase(setError.fulfilled, (state, action) => {
                state.error = true;
                state.errorMessage = action.payload;
            })
            // Reset errors
            .addCase(resetErrors.fulfilled, (state) => {
                state.error = false;                
            })
            // Logout
            .addCase(logoutReducers.fulfilled, () => {
                return { ...initialState };
            });
    }
});

export const { errorOccured } = commonSlice.actions;
export const commonReducerActions = commonSlice.actions;
export const commonState = (state: RootState) => state.common;
export default commonSlice.reducer;
